import React, { useState, useContext, useEffect } from 'react';
import { Toggle } from '../../components/ui/Toggle';
import { ChatbotContext } from '../../contexts/ChatbotContext';
import { APIContext } from '../../contexts/APIContext';
import { SessionContext } from '../../contexts/SessionContext';
import { CHAT_TAB_VIEWS, ResponseWithSource, SourceType } from '../../types';
import { useToast } from '../../components/ui/toast/UseToast';
import { ToastAction } from '../../components/ui/toast/Toast';
import { copyToClipboard, joinClassnames, trackUserClicks } from '../../utils';
import { Tooltip, TooltipProvider, TooltipTrigger } from '../../components/ui/Tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import ThumpsUpForm from '../../components/ThumpsUpForm';
import ThumpsDownForm from '../../components/ThumpsDownForm';
import { scrollToBottom } from '../chatUtils';
import ViewSource from './ViewSource';
import { SourceResponseModal } from '../../components/SourceResponseModal';
import { getValidToken } from '../../utils';
type ButtonNames = 'add' | 'heart' | 'like' | 'dislike';

const ScoringWidget = (props: any) => {
  // Gathering payload
  const { payload, actionProvider, chatHistoryActive } = props;
  // Grab states from ChatbotContext
  const {
    storyResponses,
    setStoryResponses,
    activeChatTab,
    setActiveChatTab,
    genArcHistoryPrompts,
    isLikeActive,
    isDislikeActive,
    setShowChatHistoryPanel,
    showRightPanel,
    setShowRightPanel,
  } = useContext(ChatbotContext);
  // Grab state from session context
  const {
    websocketConnectionRef: { current: websocket },
    chatSessionId,
    userDetails,
    WBUId,
    AppName,
    accounts,
    batchType,
  } = useContext(APIContext);
  const { setIsPromptRetried, isPromptGenerating, openAI, setOpenAI, genAI, setGenAI, setPromptRetriedSource } =
    useContext(SessionContext);
  // Use toast() to display a toast message
  const { toast } = useToast();
  // Set repsonse from payload
  const response: string = payload ? payload.chatResponse?.text : 'default response';
  // Set market from payload
  const market: string = payload ? payload.chatResponse?.market : '<market>';
  // Set repsonseID from payload
  const responseID: string = payload ? payload.chatResponse?.responseId : '123';
  //Set GenArcPromptAnalyticsUId from payload
  const genArcPromptAnalyticsUId: string = payload ? payload.chatResponse?.GenArcPromptAnalyticsUId : '123';
  //Set projectname from payload
  const projectname: string[] = payload ? payload.chatResponse?.projectname : null;

  // Determine whether the "add" button should be enabled for response ID
  const addButtonEnabled = storyResponses.some((resp) => resp.genArcPromptAnalyticsUId === genArcPromptAnalyticsUId);
  // State to keep track of the selected button
  const [heartButtonEnabled, setHeartButtonEnabled] = useState<ButtonNames | boolean>();
  const [likeButtonEnabled, setLikeButtonEnabled] = useState<ButtonNames | boolean>();
  const [dislikeButtonEnabled, setDislikeButtonEnabled] = useState<ButtonNames | boolean>();
  const [selectedScoringButton, setSelectedScoringButton] = useState<ButtonNames | null>(null);
  const [thumpsUpForm, setThumpsUpForm] = useState<boolean>(false);
  const [thumpsDownForm, setThumpsDownForm] = useState<boolean>(false);
  const [source, setSource] = useState<boolean>(false);
  const [sourceResponseModAL, setSourceResponseModAL] = useState<boolean>(false);
  const [viewList, setViewList] = useState([]);
  const [showAllViewList, setShowAllViewList] = useState(false);
  const [FeedbackSubmit, setFeedbackSubmit] = useState(true);
  const [tooltipContent, setTooltipContent] = useState('Add to Storybuilder');

  // Function to toggle the display of all viewList items
  const handleViewList = () => {
    setShowAllViewList(!showAllViewList);
  };

  // Set source repsonse from payload
  const sourceResponse: string = payload?.chatResponse?.responseSource;

  // Set gearcview from payload
  const genarc_viewsource_success: boolean = payload ? payload.chatResponse?.genarc_viewsource?.isSuccess : false;
  const genarc_viewsource = genarc_viewsource_success ? payload.chatResponse?.genarc_viewsource : null;

  useEffect(() => {
    handlegenArcView();
  }, []);

  // function to call each object of genarc
  const handlegenArcView = () => {
    const ViewSourceList: any = [];
    const gsResultList: any = [];
    const microResultList: any = [];
    const searchResultList: any = [];
    const secResultList: any = [];
    const tlResultList: any = [];
    const vipsightList: any = [];
    // const esgFactList: any = [];

    //gs_results
    if (genarc_viewsource?.gs_results?.length > 0) {
      genarc_viewsource?.gs_results?.map((obj: any) => {
        const gsPopObj = {
          eventTitle: '',
          speakerName: '',
          speakerInfo: '',
          content: '',
        };
        gsPopObj.eventTitle = obj.EventTitle;
        gsPopObj.speakerName = obj.SpeakerName;
        gsPopObj.speakerInfo = obj.SpeakerInfo;
        gsPopObj.content = obj.Content;
        gsResultList.push(gsPopObj);
      });
      ViewSourceList.push({
        dataSource: genarc_viewsource.gs_results[0].Datasource,
        data: gsResultList,
        action: 'Popup',
      });
    }
    //micro
    if (genarc_viewsource?.micro_results?.length > 0) {
      const uniqueDataSources = new Set(); // Set to keep track of unique data sources
      genarc_viewsource?.micro_results?.map((obj: any) => {
        const microObj = {
          dataSource: '',
          action: 'hover',
          hoverLabel: '',
        };
        microObj.dataSource = obj.Datasource;
        microObj.hoverLabel = obj.Datasource;
        if (!uniqueDataSources.has(microObj.dataSource)) {
          uniqueDataSources.add(microObj.dataSource);

          microResultList.push(microObj);
          ViewSourceList.push(microObj);
        }
      });
    }
    //search_results
    if (genarc_viewsource?.search_results?.length > 0) {
      const uniquesearch_results = new Set();
      genarc_viewsource?.search_results?.map((obj: any) => {
        const searchObj = {
          dataSource: '',
          action: '',
          hoverLabel: '',
          link: '',
          type: '',
        };
        searchObj.dataSource = obj.Name;
        searchObj.link = obj.Url;
        searchObj.action = 'link';
        searchObj.hoverLabel = obj.Name;
        if (!uniquesearch_results.has(searchObj.dataSource)) {
          uniquesearch_results.add(searchObj.dataSource);
          (searchObj.type = obj.Type), searchResultList.push(obj);
          ViewSourceList.push(searchObj);
        }
      });
    }
    // sec_results
    if (genarc_viewsource?.sec_results?.length > 0) {
      genarc_viewsource?.sec_results?.map((obj: any) => {
        const secPopObj = {
          eventTitle: '',
          content: '',
        };
        secPopObj.eventTitle = obj.EventTitle;
        secPopObj.content = obj.Content;
        secResultList.push(secPopObj);
      });
      ViewSourceList.push({
        dataSource: genarc_viewsource.sec_results[0].Datasource,
        data: secResultList,
        action: 'Popup',
      });
    }
    // tl_results
    if (genarc_viewsource?.tl_results?.length > 0) {
      genarc_viewsource?.tl_results?.map((obj: any) => {
        const tlResultPopObj = {
          eventTitle: '',
          content: '',
          Url: '',
        };
        tlResultPopObj.eventTitle = obj.Title;
        tlResultPopObj.content = obj.Content;
        tlResultPopObj.Url = obj.Url;
        tlResultList.push(tlResultPopObj);
      });
      ViewSourceList.push({
        dataSource: genarc_viewsource.tl_results[0].Datasource,
        data: tlResultList,
        action: 'Popup',
      });
    }
    //vipsight_results
    if (genarc_viewsource?.vipsight_results?.length > 0) {
      genarc_viewsource.vipsight_results.map((obj: any) => {
        const vipSightObj = {
          dataSource: '',
          CompanyName: '',
          Url: '',
        };
        vipSightObj.dataSource = obj.Datasource;
        vipSightObj.Url = obj.Url;
        vipSightObj.CompanyName = obj.CompanyName;
        vipsightList.push(vipSightObj);
      });
      ViewSourceList.push({
        dataSource: genarc_viewsource.vipsight_results[0].Datasource,
        data: vipsightList,
        action: genarc_viewsource.vipsight_results[0].Action,
      });
    }
    //esgFactList
    // if (genarc_viewsource?.esg_sustainability_results?.length > 0) {
    //   const uniqueEsgDataSources = new Set(); // Set to keep track of unique data sources
    //   genarc_viewsource?.esg_sustainability_results?.map((obj: any) => {
    //     const esgObj = {
    //       dataSource: '',
    //       action: 'hover',
    //       hoverLabel: '',
    //     };
    //     esgObj.dataSource = obj.Datasource;
    //     esgObj.hoverLabel = obj.Datasource;
    //     if (!uniqueEsgDataSources.has(esgObj.dataSource)) {
    //       uniqueEsgDataSources.add(esgObj.dataSource);
    //       esgFactList.push(esgObj);
    //       ViewSourceList.push(esgObj);
    //     }
    //   });
    // }
    setViewList(ViewSourceList);
    console.log(viewList);
  };

  const openRightPanel = () => {
    setShowRightPanel(true);
    setShowChatHistoryPanel(false);
  };

  // Function to handle button click
  const handleButtonClick = async (buttonName: ButtonNames) => {
    const token = await getValidToken();
    if (buttonName === 'add') {
      if (addButtonEnabled) {
        //display toast when user removes response from story builder through '+' icon
        toast({
          status: 'success',
          description: 'Removed from Storybuilder',
          action: (
            <ToastAction
              altText="View Storybuilder"
              onClick={() => {
                openRightPanel();
                setActiveChatTab(CHAT_TAB_VIEWS.STORYBUILDER);
              }}
              className="flex items-center justify-center w-[max-content] h-full font-graphik text-[16px] tracking-[-0.32px] text-gamma-purple"
            >
              View Storybuilder
            </ToastAction>
          ),
        });
        // Remove the response from the story
        const updatedStoryResponse = storyResponses.filter(
          (resp) => resp.genArcPromptAnalyticsUId !== genArcPromptAnalyticsUId
        );
        setStoryResponses(updatedStoryResponse);
      } else {
        // Add the response to the story
        trackUserClicks(websocket, 'StoryBuilder', userDetails, chatSessionId, WBUId, AppName, accounts, token);
        const newResponse: ResponseWithSource = {
          responseId: responseID,
          market: market,
          response: response,
          source: sourceResponse,
          genArcPromptAnalyticsUId: genArcPromptAnalyticsUId,
          projectName: projectname,
        };
        console.log(newResponse);
        setStoryResponses([...storyResponses, newResponse]);
        // Display toast notification if the user isn't on the "Storybuilder" tab or the right panel is closed
        toast({
          status: 'success',
          description: chatHistoryActive ? 'Chat History has been added to storybuilder' : 'Added to the storybuilder',
          action:
            activeChatTab !== CHAT_TAB_VIEWS.STORYBUILDER ? (
              <ToastAction
                altText="View Storybuilder"
                onClick={() => {
                  openRightPanel();
                  setActiveChatTab(CHAT_TAB_VIEWS.STORYBUILDER);
                }}
                className="flex items-center justify-center w-[max-content] h-full font-graphik text-[16px] tracking-[-0.32px] text-gamma-purple"
              >
                View Storybuilder
              </ToastAction>
            ) : undefined,
        });
      }
    }
    if (buttonName === 'heart') {
      setHeartButtonEnabled(!heartButtonEnabled);
      setDislikeButtonEnabled(false);
    }
    if (buttonName === 'like') {
      setLikeButtonEnabled(true);
      setThumpsUpForm(true);
      setTimeout(() => {
        scrollToBottom('.Prompt-feedback', 0);
      }, 100);
      setDislikeButtonEnabled(false);
      setThumpsDownForm(false);
    }
    if (buttonName === 'dislike') {
      setDislikeButtonEnabled(true);
      setThumpsDownForm(true);
      setTimeout(() => {
        scrollToBottom('.Prompt-feedback', 0);
      }, 100);
      setHeartButtonEnabled(false);
      setThumpsUpForm(false);
      setLikeButtonEnabled(false);
    } else {
      // Placeholder for handling other buttons
      if (selectedScoringButton === buttonName) {
        console.log(`Button ${buttonName} toggled off`);
      } else {
        console.log(`Button ${buttonName} toggled on`);
      }
      // toggle between other buttons
      setSelectedScoringButton((prevButton) => (prevButton === buttonName ? null : buttonName));
    }
  };

  // Function to handle openAI button click
  const handleOpenAIClick = () => {
    setIsPromptRetried(true);
    setPromptRetriedSource('openAI');
    const prompt = genArcHistoryPrompts[responseID];
    const predefinedPrompts = userDetails?.ConfigurationDetails?.PredefinedPrompts;
    const filteredPrompts = predefinedPrompts.filter((item: any) => {
      return item.PromptName === prompt;
    });
    const isPredefinedPrompt = filteredPrompts.length > 0 ? true : false;
    if (isPredefinedPrompt) {
      actionProvider.handleUserAction(prompt, true, false, true);
    } else {
      actionProvider.handleUserMessage(prompt, true, false, true);
    }
  };

  // Function to handle genAI button click
  const handleGenAIClick = () => {
    setIsPromptRetried(true);
    setPromptRetriedSource('genAI');
    const prompt = genArcHistoryPrompts[responseID];
    const predefinedPrompts = userDetails?.ConfigurationDetails?.PredefinedPrompts;
    const filteredPrompts = predefinedPrompts.filter((item: any) => {
      return item.PromptName === prompt;
    });
    const isPredefinedPrompt = filteredPrompts.length > 0 ? true : false;
    if (isPredefinedPrompt) {
      actionProvider.handleUserAction(prompt, false, true, true);
    } else {
      actionProvider.handleUserMessage(prompt, false, true, true);
    }
  };

  const handleTextCopy = async () => {
    const rootResponseEle = document.getElementById(`response-${responseID}`);
    try {
      if (rootResponseEle) {
        await copyToClipboard(rootResponseEle);
        toast({
          status: 'success',
          description: 'Content copied successfully',
        });
      }
      // eslint-disable-next-line no-empty
    } catch (err) {}
  };

  if (sourceResponse === SourceType.GENAI && genarc_viewsource_success === false) {
    return null;
  }

  return (
    <>
      <div className="border-[1px] border-gamma-bg-purple-bottom border-t-transparent p-2 mb-2.5">
        <div
          className={`flex justify-between mb:justify-end relative ${isPromptGenerating && 'not-clickable opacity-50'}`}
        >
          <div className="overlay hidden mb:block absolute h-full w-full bg-[#f1f1f180]"></div>
          <div className="text-base font-light ml-4 mb:hidden">
            Source: <span className="font-normal">{sourceResponse}</span>
          </div>
          <div className="flex flex-row-reverse gap-2 tb:pointer-events-none">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Toggle
                    onClick={() => handleOpenAIClick()}
                    data-state={source ? 'on' : 'off'} // Control the toggle state for the "openAi" button
                    className={joinClassnames(
                      source ? '!bg-[transparent]' : '!bg-[transparent]',
                      'rounded-md w-4 h-4 px-0] bg-[transparent]',
                      isPromptGenerating || !(batchType == 'complete') ? 'not-clickable' : ''
                    )}
                  >
                    <input
                      id="myImageOpenAI"
                      type="image"
                      src={sourceResponse !== 'Azure OpenAI' ? '/icons/enableOpenAI.svg' : '/icons/disableOpenAI.svg'}
                      onMouseEnter={(e) => {
                        if (sourceResponse !== 'Azure OpenAI') {
                          e.currentTarget.setAttribute('src', '/icons/activeOpenAIicon.svg');
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (sourceResponse !== 'Azure OpenAI') {
                          e.currentTarget.setAttribute('src', '/icons/enableOpenAI.svg');
                        }
                      }}
                      alt="Submit"
                      className="w-4 h-4"
                      disabled={sourceResponse === 'Azure OpenAI'}
                    ></input>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 z-10"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base not-italic">Re-run with Azure OpenAI</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger>
                  <Toggle
                    onClick={() => handleGenAIClick()}
                    data-state={source ? 'on' : 'off'} // Control the toggle state for the "genAi" button
                    className={joinClassnames(
                      source ? '!bg-[transparent]' : '!bg-[transparent]',
                      'rounded-md w-4 h-4 px-0] bg-[transparent]',
                      isPromptGenerating || !(batchType == 'complete') ? 'not-clickable cursor-default' : ''
                    )}
                  >
                    <input
                      id="myImageGenAI"
                      type="image"
                      src={
                        sourceResponse === SourceType.GENAI
                          ? '/icons/disableGenIcon.svg'
                          : '/icons/defaultGenAIIcon.svg'
                      }
                      onMouseEnter={(e) => {
                        if (sourceResponse !== SourceType.GENAI) {
                          e.currentTarget.setAttribute('src', '/icons/activeGenAIicon.svg');
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (sourceResponse !== SourceType.GENAI) {
                          e.currentTarget.setAttribute('src', '/icons/defaultGenAIIcon.svg');
                        }
                      }}
                      alt="Submit"
                      className="w-4 h-4"
                      disabled={sourceResponse === SourceType.GENAI}
                    ></input>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 z-10"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base not-italic">
                    Re-run with &apos;Generate Insights&apos;
                  </p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>

              <Tooltip>
                <TooltipTrigger className={chatHistoryActive && 'cursor-default'}>
                  <Toggle
                    onClick={() => handleButtonClick('dislike')}
                    data-state={dislikeButtonEnabled || (isDislikeActive && chatHistoryActive) ? 'on' : 'off'} // Control the toggle state for the "dislike" button
                    className={joinClassnames(
                      dislikeButtonEnabled || (isDislikeActive && chatHistoryActive)
                        ? '!bg-[transparent]'
                        : '!bg-[transparent]',
                      'rounded-md w-4 h-4 px-0] bg-[transparent]',
                      isPromptGenerating || chatHistoryActive ? 'not-clickable' : ''
                    )}
                    disabled={!FeedbackSubmit}
                  >
                    <img
                      className="w-4 h-4"
                      src={
                        dislikeButtonEnabled || (isDislikeActive && chatHistoryActive)
                          ? '/icons/disLikeIcon.svg'
                          : '/icons/disLikeIconDisable.svg'
                      }
                      onMouseEnter={(e) => {
                        if (!thumpsDownForm && !dislikeButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/disLikeIcon.svg');
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!thumpsDownForm && !dislikeButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/disLikeIconDisable.svg');
                        }
                      }}
                    ></img>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base capitalize not-italic">Bad response</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>

              <Tooltip>
                <TooltipTrigger className={chatHistoryActive && 'cursor-default'}>
                  <Toggle
                    onClick={() => handleButtonClick('like')}
                    data-state={likeButtonEnabled || (isLikeActive && chatHistoryActive) ? 'on' : 'off'} // Control the toggle state for the "like" button
                    className={joinClassnames(
                      likeButtonEnabled || (isLikeActive && chatHistoryActive)
                        ? '!bg-[transparent]'
                        : '!bg-[transparent]',
                      'rounded-md w-4 h-4 px-0] bg-[transparent]',
                      isPromptGenerating || chatHistoryActive ? 'not-clickable' : ''
                    )}
                    disabled={!FeedbackSubmit}
                  >
                    <img
                      className="w-4 h-4"
                      src={
                        likeButtonEnabled || (isLikeActive && chatHistoryActive)
                          ? '/icons/likeIcon.svg'
                          : '/icons/likeIconDisable.svg'
                      }
                      onMouseEnter={(e) => {
                        if (!thumpsUpForm && !likeButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/likeIcon.svg');
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!thumpsUpForm && !likeButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/likeIconDisable.svg');
                        }
                      }}
                    ></img>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base capitalize not-italic">Good response</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger className={addButtonEnabled ? 'cursor-default' : ''}>
                  <Toggle
                    onClick={() => handleButtonClick('add')}
                    data-state={addButtonEnabled ? 'on' : 'off'} // Control the toggle state for the "add" button
                    className={joinClassnames(
                      addButtonEnabled ? '!bg-[transparent]' : '!bg-[transparent]',
                      'rounded-md w-4 h-4 px-0] bg-[transparent]',
                      isPromptGenerating || addButtonEnabled ? 'not-clickable' : ''
                    )}
                  >
                    <img
                      className="w-4 h-4"
                      src={addButtonEnabled ? '/icons/addIcon.svg' : '/icons/addIconDisable.svg'}
                      onMouseEnter={(e) => {
                        addButtonEnabled
                          ? setTooltipContent('Added to Storybuilder')
                          : setTooltipContent('Add to Storybuilder');
                        if (!addButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/addIconActive.svg');
                        }
                      }}
                      onMouseLeave={(e) => {
                        addButtonEnabled
                          ? setTooltipContent('Added to Storybuilder')
                          : setTooltipContent('Add to Storybuilder');
                        if (!addButtonEnabled) {
                          e.currentTarget.setAttribute('src', '/icons/addIconDisable.svg');
                        }
                      }}
                    ></img>
                  </Toggle>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base not-italic">{tooltipContent}</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger>
                  <div className="w-5 h-5 px-0">
                    <input
                      onClick={handleTextCopy}
                      id="scoring-widget-copyIcon"
                      type="image"
                      src={'/icons/contentCopyIcon.svg'}
                      alt="Submit"
                      className={joinClassnames('w-5 h-5 bg-[transparent]', isPromptGenerating ? 'not-clickable' : '')}
                    ></input>
                  </div>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="bg-[#505050] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 z-10"
                  sideOffset={5}
                >
                  <p className="tooltip-content text-white text-base not-italic">Copy</p>
                  <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#505050' }} />
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <Toggle
              onClick={() => handleButtonClick('heart')}
              data-state={heartButtonEnabled ? 'on' : 'off'} // Control the toggle state for the "add" button
              className={joinClassnames(
                heartButtonEnabled ? '!bg-[transparent]' : '!bg-[transparent]',
                'rounded-md w-4 h-4 px-0] bg-[transparent] hidden'
              )}
            >
              <img
                className="w-4 h-4"
                src={heartButtonEnabled ? '/icons/HeartIcon.svg' : '/icons/HeartIconDisabled.svg'}
              ></img>
            </Toggle>
          </div>
        </div>
        {genarc_viewsource_success
          ? viewList.length > 0 && (
              <div className={`flex ${isPromptGenerating && 'not-clickable opacity-50'}`}>
                <div className="flex-none items-center text-sm font-light ml-1 mt-1">
                  <p className="w-24">View Source:</p>
                </div>
                <div className="flex-wrap gap-2 flex text-sm font-light ml-1 mt-1">
                  <TooltipProvider>
                    {viewList.slice(0, showAllViewList ? viewList.length : 3).map((obj: any, index) => (
                      <Tooltip key={index}>
                        <TooltipTrigger>
                          <ViewSource list={obj} />
                        </TooltipTrigger>
                        <TooltipContent
                          side="bottom"
                          className="bg-[#FAFAFA] border-0 max-w-[218px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2 rounded-sm z-10 overflow-hidden whitespace-normal break-words"
                          sideOffset={5}
                        >
                          <p className="tooltip-content text-sm not-italic font-normal text-[#000000]">
                            {obj.type && <span>{obj.type}: </span>}
                            {obj?.dataSource}
                          </p>
                          <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#FAFAFA' }} />
                        </TooltipContent>
                      </Tooltip>
                    ))}
                    {viewList.length > 3 && !showAllViewList && (
                      <div>
                        <span
                          className="border border-[#A100FF] rounded-full px-1 font-semibold cursor-pointer"
                          onClick={handleViewList}
                        >
                          +{viewList.length - 3}
                        </span>
                      </div>
                    )}
                  </TooltipProvider>
                  <span className="font-light text-base"></span>
                </div>
              </div>
            )
          : null}
      </div>
      {thumpsUpForm ? (
        <ThumpsUpForm
          likeButtonEnabled={setLikeButtonEnabled}
          thumpsUpEnableForm={setThumpsUpForm}
          responseID={responseID}
          FeedbackSubmit={setFeedbackSubmit}
        />
      ) : null}
      {thumpsDownForm ? (
        <ThumpsDownForm
          dislikeButtonEnabled={setDislikeButtonEnabled}
          thumpsDownEnableForm={setThumpsDownForm}
          responseID={responseID}
          FeedbackSubmit={setFeedbackSubmit}
        />
      ) : null}
      {sourceResponseModAL ? (
        <SourceResponseModal
          sourceResponseModAL={sourceResponseModAL}
          setSourceResponseModAL={setSourceResponseModAL}
        />
      ) : null}
    </>
  );
};

export default ScoringWidget;
